<div class="row" *ngIf="title !== undefined">
  <div class="col-4"><label>{{title}}</label></div>
  <div class="col-8">
    <div class="form-group">
      <input class="form-check-input col-md-1" type="checkbox" [(ngModel)]="value" (change)="updateValue($any($event.target).checked)" [attr.disabled]="disabled ? true : null">
    </div>
  </div>
</div>

<div *ngIf="title === undefined" class="col-md-8">
  <div class="form-group">
      <div class="form-check">
        <input class="form-check-input col-md-1" type="checkbox" [(ngModel)]="value" (change)="updateValue($any($event.target).checked)" [attr.disabled]="disabled ? true : null">
        <label class="form-check-label col-md-11">
          {{name}}
        </label>
    </div>
  </div>
</div>
